<template>
    <section>
        <div class="upload-photos-preview-container-xs">
            <vue-dropzone
                id="customdropzone"
                :use-custom-slot="true"
                :options="dropzoneOptions"
                @vdropzone-thumbnail="thumbnail"
                @vdropzone-file-added="fileAdded"
                @vdropzone-success-multiple="uploadSuccess"
                @vdropzone-removed-file="removeFiles"
                @vdropzone-queue-complete="completeUpload"
            >
                <input
                    ref="inputFile"
                    accept=".jpg, .JPEG, .png, .pdf, .txt, .gif"
                    type="file"
                    multiple
                />
                <div class="text-center">
                    <img src="../assets/upload-photo-icon.svg" alt="" />
                    <p class="supported-format-text">
                        Supported Formats <b>JPG</b>, <b>JPEG</b> ,<b>PNG</b>,<b>PDF</b>
                    </p>
                </div>
            </vue-dropzone>
            <div
                v-if="showExtraUploadButton && uploadedFilesSrc.length > 0"
                class="add-extra-photo"
                @click="addExtraFile"
            >
                <img src="../assets/upload-icon.svg" alt="" width="32" />
            </div>
        </div>
        <div class="mt-4 d-flex justify-content-center align-items-center">
            <button :disabled="disabledSubmitBtn" :class="[submitBtnClass]" @click="createTicket">
                <img v-if="requestLoading" src="@/assets/spinner.svg" alt="" />
                <span v-else>Submit</span>
            </button>
        </div>
        <div class="notification-container-xl">
            <transition
                v-if="showNotification"
                enter-active-class="animate__animated animate__slideInLeft"
                leave-active-class="animate__animated animate__slideOutRight"
            >
                <Notification
                    :message="notificationMessage"
                    :status="notificationStatus"
                    @hideNotification="showNotification = false"
                />
            </transition>
        </div>
    </section>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import baseApiAddress from '@/axios.config';
import Notification from '@/components/snacks/index.vue';
import vue2Dropzone from 'vue2-dropzone';
import '../styles/vue2Dropzone.min.css';

export default {
    components: { Notification, vueDropzone: vue2Dropzone },
    data() {
        return {
            notificationMessage: '',
            notificationStatus: '',
            showNotification: false,

            uploadedFiles: [],
            requestLoading: false,
            showExtraUploadButton: false,
            orderImages: [],
            uploadingFile: false,

            dropzoneOptions: {
                url: `${process.env.VUE_APP_BASE_URL}/tickets/upload-file`,
                thumbnailWidth: 32,
                thumbnailHeight: 32,
                maxFilesize: 20,
                uploadMultiple: true,
                paramName: 'attachments',
                maxThumbnailFilesize: 50,
                autoProcessQueue: true,
                timeout: 90000,
                previewTemplate: this.template(),
                acceptedFiles: '.jpg,.webp,.png,.jpeg,.pdf',
                parallelUploads: 4,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                init: function () {
                    let dropzone = this;
                    this.on('addedfiles', (files) => {
                        for (let i = 0; i < files.length; i++) {
                            if (files[i].status === 'queued') {
                                dropzone.processFile(files[i]);
                            }
                        }
                    });
                },
            },
        };
    },

    computed: {
        ...mapState({
            subject: (state) => state.createTicketStore.subject,
            description: (state) => state.createTicketStore.description,
            selectedCategoryId: (state) => state.createTicketStore.selectedCategoryId,
            uploadedFilesSrc: (state) => state.createTicketStore.uploadedFilesSrc,
        }),
        submitBtnClass() {
            if (
                this.subject === '' ||
                this.description === '' ||
                this.selectedCategoryId === null ||
                this.uploadingFile
            ) {
                return 'upload-photos-btn-inactive';
            }
            return 'upload-photos-btn-active';
        },
        disabledSubmitBtn() {
            if (
                this.subject === '' ||
                this.description === '' ||
                this.selectedCategoryId === null ||
                this.requestLoading ||
                this.uploadingFile
            ) {
                return true;
            }
            return false;
        },
    },
    methods: {
        fileAdded(file, xhr) {
            this.uploadingFile = true;
            this.showExtraUploadButton = true;
        },
        addExtraFile() {
            this.$refs.inputFile.click();
        },
        removeFiles(file, error, xhr) {
            const selectedFileId = file.upload.uuid;
            this.$store.commit('createTicketStore/REMOVE_UPLOADED_FILES', selectedFileId);
        },
        completeUpload() {
            this.uploadingFile = false;
        },

        fileThumbnailHandler(files) {
            const filesType = ['image/jpeg', 'image/png', 'image/jpg'];
            files.map(({ name, type, previewElement }) => {
                const isImageType = _.includes(filesType, type);
                const thumbnailElement =
                    previewElement.querySelectorAll('[data-dz-thumbnail-bg]')[0];
                thumbnailElement.alt = name;
                thumbnailElement.style.height = '100%';
                thumbnailElement.style.backgroundSize = 'contain';
                thumbnailElement.style.backgroundPosition = 'center';
                thumbnailElement.style.backgroundRepeat = 'no-repeat';

                if (isImageType) {
                    thumbnailElement.style.backgroundImage =
                        process.env.NODE_ENV != 'development'
                            ? `url('/dashboard/assets/image-type-icon.svg')`
                            : `url('/assets/image-type-icon.svg')`;
                } else {
                    thumbnailElement.style.backgroundImage =
                        process.env.NODE_ENV != 'development'
                            ? 'url("/dashboard/assets/file-type-icon.svg")'
                            : 'url("/assets/file-type-icon.svg")';
                }
            });
        },

        uploadSuccess(files, response) {
            this.fileThumbnailHandler(files);

            const { data } = response;
            data.map((item, index) => {
                item.uuid = files[index].upload.uuid;
                this.$store.commit('createTicketStore/HANDLE_UPLOADED_FILES', item);
            });
        },

        template() {
            return `<div  id="mytmp" class="dz-preview dz-file-preview">
            <div class="dz-image">
            <div data-dz-thumbnail-bg></div>
        </div>
        <div class="dz-details">
            <div class="dz-filename"><span data-dz-name></span></div>
        </div>
        <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
        <div class="dz-error-message"><span data-dz-errormessage></span></div>
        <div class="dz-success-mark">
            <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16" cy="16" r="16" fill="#4ABE7D"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7598 21.8318C12.776 21.8497 12.7927 21.8672 12.8099 21.8844C13.3124 22.3869 14.0827 22.4584 14.6613 22.0988C14.7578 22.039 14.849 21.9672 14.9327 21.8835C14.9411 21.8752 14.9493 21.8668 14.9574 21.8583L23.6778 13.1378C24.2636 12.552 24.2636 11.6023 23.6778 11.0165C23.0921 10.4307 22.1423 10.4307 21.5565 11.0165L13.8718 18.7012L11.6201 16.4495C11.0343 15.8637 10.0846 15.8637 9.49879 16.4495C8.913 17.0353 8.913 17.985 9.49879 18.5708L12.7598 21.8318Z" fill="white"/>
        </svg>
        </div>
        <div class="dz-error-mark"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.7369 1.0802C13.5778 0.756111 13.3311 0.483096 13.0246 0.292151C12.7182 0.101206 12.3643 0 12.0032 0C11.6421 0 11.2882 0.101206 10.9817 0.292151C10.6753 0.483096 10.4285 0.756111 10.2695 1.0802L0.166064 21.6643C0.044426 21.912 -0.0120095 22.1864 0.00213005 22.4619C0.0162696 22.7374 0.100526 23.0048 0.246875 23.2386C0.393224 23.4725 0.596836 23.6652 0.838469 23.7985C1.0801 23.9317 1.35175 24.001 1.62769 24H22.3787C22.6535 23.9981 22.9235 23.927 23.1635 23.793C23.4035 23.659 23.6057 23.4666 23.7515 23.2337C23.8973 23.0007 23.9819 22.7347 23.9974 22.4603C24.0129 22.186 23.9589 21.9122 23.8403 21.6643L13.7369 1.0802Z" fill="#FF6767"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.749 8.00293C12.749 7.58872 12.4132 7.25293 11.999 7.25293C11.5848 7.25293 11.249 7.58872 11.249 8.00293V16.0019C11.249 16.4161 11.5848 16.7519 11.999 16.7519C12.4132 16.7519 12.749 16.4161 12.749 16.0019V8.00293ZM11.2369 18.8009C11.3905 18.6201 11.6033 18.4997 11.8374 18.4614C11.9805 18.4379 12.127 18.446 12.2667 18.4848C12.4064 18.5236 12.536 18.5924 12.6466 18.6862C12.7571 18.7801 12.8458 18.8968 12.9067 19.0284C12.9676 19.16 12.9991 19.3032 12.9991 19.4482C12.9991 19.5932 12.9676 19.7365 12.9067 19.8681C12.8458 19.9997 12.7571 20.1164 12.6466 20.2103C12.536 20.3041 12.4064 20.3729 12.2667 20.4117C12.127 20.4505 11.9805 20.4586 11.8374 20.4351C11.6033 20.3968 11.3905 20.2763 11.2369 20.0956C11.0833 19.9148 10.999 19.6854 10.999 19.4482C10.999 19.211 11.0833 18.9817 11.2369 18.8009Z" fill="white"/>
            </svg>
        </div>
        <div class="dz-remove" data-dz-remove>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22.75C14.1261 22.75 16.2045 22.1195 17.9724 20.9383C19.7402 19.7571 21.1181 18.0782 21.9317 16.1139C22.7453 14.1496 22.9582 11.9881 22.5434 9.90276C22.1286 7.81744 21.1048 5.90214 19.6014 4.39875C18.098 2.89537 16.1825 1.87132 14.0972 1.45652C12.0119 1.04172 9.85041 1.2548 7.88615 2.06842C5.92188 2.88205 4.24296 4.25974 3.06172 6.02759C1.8805 7.79542 1.25 9.87388 1.25 12C1.25 14.8511 2.38258 17.5853 4.39859 19.6013C6.41459 21.6173 9.14889 22.75 12 22.75Z" fill="#EAEAEA" stroke="#FCFCFC" stroke-width="1.5"/>
            <path d="M8 16L16 8" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16 16L8 8" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
            </div>`;
        },
        thumbnail: function (file, dataUrl) {
            // const types = ['image/jpeg', 'image/png', 'image/jpg'];
            // var j, len, ref, thumbnailElement;
            // if (file.previewElement) {
            //     file.previewElement.classList.remove('dz-file-preview');
            //     ref = file.previewElement.querySelectorAll('[data-dz-thumbnail-bg]');
            //     for (j = 0, len = ref.length; j < len; j++) {
            //         thumbnailElement = ref[j];
            //         thumbnailElement.alt = file.name;
            //         thumbnailElement.style.height = '100%';
            //         thumbnailElement.style.backgroundImage = _.includes(types, file.type)
            //             ? `url('/assets/image-type-icon.svg')`
            //             : 'url("/assets/file-type-icon.svg")';
            //         thumbnailElement.style.backgroundSize = 'cover';
            //     }
            //     return setTimeout(
            //         (function (_this) {
            //             return function () {
            //                 return file.previewElement.classList.add('dz-image-preview');
            //             };
            //         })(this),
            //         1
            //     );
            // }
        },

        selectInput() {
            this.$refs.inputFile.click();
        },
        fileTypeValidation(type) {
            const types = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];

            return _.includes(types, type);
        },
        deleteImage(event, index) {
            event.stopPropagation();
            this.uploadedFiles.splice(index, 1);
        },
        async createTicket() {
            try {
                this.requestLoading = true;
                const createTicketData = {
                    ticket_category_id: this.selectedCategoryId,
                    subject: this.subject,
                    description: this.description,
                    attachments: this.uploadedFilesSrc,
                };

                const { status, data } = await baseApiAddress({
                    method: 'post',
                    url: '/tickets/create-ticket',
                    data: createTicketData,
                });
                if (status >= 200 && status < 300) {
                    this.requestLoading = false;
                    this.showNotification = true;
                    this.notificationStatus = 'success';
                    this.notificationMessage = 'Your ticket has been successfully registered';
                    setTimeout(() => {
                        this.showNotification = false;
                        this.$store.commit('createTicketStore/RESET_STATE');
                        this.$router.push('/tickets');
                    }, 2000);
                }
            } catch (error) {
                this.requestLoading = false;
                this.showNotification = true;
                this.notificationStatus = 'error';
                this.notificationMessage = 'An error occurred. Please try again';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
input {
    width: 0;
    height: 0;
}
.add-extra-photo {
    position: absolute;
    bottom: 4px;
}
.upload-photos {
    &-preview-container-xs {
        border: 2px dashed $Gray-Color;
        @include centerByFlex;
        flex-direction: column;
        border-radius: 8px;
        height: 27vh;
        background: #fff;
        position: relative;
    }
    &-container {
        @include centerByFlex;
        border: 2px dashed $Gray-Color;
        height: 17.5vh;
        overflow-y: auto;
        border-radius: 8px;
        flex-wrap: wrap;
        cursor: pointer;
        input {
            width: 0;
            height: 0;
        }
    }
    &-btn {
        &-active {
            @include nextBtn(100px, 32px);
            @media (max-width: 767px) {
                @include nextBtn(100%, 32px);
            }
        }
        &-inactive {
            @include inactiveBtn(100px, 32px);
            @media (max-width: 767px) {
                @include inactiveBtn(100%, 32px);
            }
        }
    }
    &-items {
        &-outer-container {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            width: 100%;
            height: inherit;
            overflow-y: auto;
            padding: 16px;
        }
        &-inner-container {
            @include centerByFlex;
            position: relative;
            width: 126px;
            height: 96px;
            border-radius: 8px;
            background-color: $Gray-Color;
            margin: 0px 24px 24px 0;
            @media (max-width: 767px) {
                width: 80px;
                height: 52px;
            }
        }
        &-delete-icon {
            position: absolute;
            top: -8px;
            left: -10px;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: $Gray-Color;
            border: 1px solid $Background-Color;
            padding: 3px;
            cursor: pointer;
        }
        &-progress {
            &-outer-container-xl {
                background-color: #fff;
                height: 10px;
                position: absolute;
                width: 90%;
                margin: 0 auto;
                top: 50%;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                border-radius: 10px;
            }
            &-inner-container-xl {
                border-radius: 8px;
                height: 10px;
                background-color: $Accent-Light-Color;
                color: $White-Color;
            }
            &-percent-xl {
                position: absolute;
                top: -24px;
                width: 100%;
                text-align: center;
                color: $Primary-Text-Color;
                font-size: 14px;
                font-weight: bold;
            }
            &-tick-xl {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
        &-name {
            width: 100%;
            text-align: center;
            font-size: 12px;
            color: $Third-Text-Color;
            margin-top: 8px;
            margin-bottom: 0;
            @media (max-width: 767px) {
                margin-top: 4px;
            }
        }
    }
}
.notification {
    &-container-xl {
        position: fixed;
        bottom: 20px;
        right: 20px;
    }
}

.supported-format-text {
    font-size: 14px;
    color: #8d8d8d;
}

#mytmp .dz-remove {
    z-index: 999;
    position: absolute;
    display: block;
    top: 0px;
    left: 0px;
    cursor: pointer;
}
#customdropzone {
    font-family: 'Arial', sans-serif;
    letter-spacing: 0.2px;
    transition: background-color 0.2s linear;
    height: 100%;
    width: 100%;
    @media (max-width: 768px) {
        padding: 20px;
    }
}
@media (max-width: 768px) {
    #customdropzone .dz-preview .dz-image {
        width: 24px;
        height: 24px;
        margin-bottom: 10px;
    }
}
@media (min-width: 768px) {
    #customdropzone .dz-preview .dz-image {
        width: 32px;
        height: 32px;
        margin-bottom: 10px;
    }
}

#customdropzone .dz-preview .dz-image > div {
    width: inherit;
    height: inherit;
    border-radius: 10px;
    background-size: contain;
}
#customdropzone .dz-preview .dz-image > img {
    width: 100%;
}

#customdropzone .dz-preview .dz-details {
    color: white;
    transition: opacity 0.2s linear;
    text-align: center;
}
#customdropzone .dz-success-mark,
.dz-error-mark,
.dz-remove {
    /* display: none; */
    cursor: pointer;
    width: 24px;
    height: 24px;
}
</style>
